import { Link, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { Logo } from "./Logo";

function tabClass({ isActive }) {
  return [
    "flex flex-col items-center justify-center gap-0.5 text-xs font-medium transition-colors",
    isActive ? "text-brand-600" : "text-slate-500 hover:text-slate-700",
  ].join(" ");
}

export function NavBar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  // Absolute paths, so they must carry the /gear prefix the shell mounts us at.
  const tabs = [
    { to: "/gear", label: "Browse", end: true },
    { to: "/gear/sell", label: "Sell" },
    { to: "/gear/my-listings", label: "My Gear" },
    { to: "/gear/messages", label: "Messages" },
    { to: "/gear/alerts", label: "Alerts" },
    ...(user?.isAdmin ? [{ to: "/gear/admin", label: "Admin" }] : []),
  ];
  // Help lives in the platform shell, not the app, so it's a plain link rather
  // than a tab — it leaves /gear.


  return (
    <>
      {/* Top bar */}
      <header className="sticky top-0 z-20 bg-white border-b border-slate-200">
        <div className="max-w-5xl mx-auto px-4 h-14 flex items-center justify-between">
          <Link to="/gear" className="flex items-center">
            <Logo />
          </Link>
          <div className="flex items-center gap-3">
            {/* Desktop nav */}
            <nav className="hidden sm:flex items-center gap-5">
              {tabs.map((t) => (
                <NavLink key={t.to} to={t.to} end={t.end} className={tabClass}>
                  <span className="text-sm">{t.label}</span>
                </NavLink>
              ))}
            </nav>
            <div className="hidden sm:block h-6 w-px bg-slate-200" />
            <div className="flex items-center gap-2">
              <span className="hidden sm:inline text-sm text-slate-600 max-w-[10rem] truncate">
                {user?.displayName}
              </span>
              <Link
                to="/help/gear"
                className="hidden sm:inline text-sm text-slate-500 hover:text-slate-700 font-medium"
              >
                Help
              </Link>
              <button
                onClick={() => {
                  logout();
                  navigate("/gear/login");
                }}
                className="text-sm text-slate-500 hover:text-red-600 font-medium"
              >
                Sign out
              </button>
            </div>
          </div>
        </div>
      </header>

      {/* Mobile bottom tab bar */}
      <nav className="sm:hidden fixed bottom-0 inset-x-0 z-20 bg-white border-t border-slate-200 safe-bottom">
        {/* Columns follow the tab count — Alerts and Admin took this past the
            four it used to hardcode. */}
        <div className="grid h-14" style={{ gridTemplateColumns: `repeat(${tabs.length}, minmax(0, 1fr))` }}>
          {tabs.map((t) => (
            <NavLink key={t.to} to={t.to} end={t.end} className={tabClass}>
              <span className="px-1 text-center leading-tight">{t.label}</span>
            </NavLink>
          ))}
        </div>
      </nav>
    </>
  );
}
